import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLabel } from '@platform/hooks/useLabel';
import { routes } from '@platform/core/lib/routes';
import type { IHomeCardProps } from './IHomeCardProps';
import { listedModuleCount } from './listedModuleCount';
import { moduleCount } from './moduleCount';
import { setNavigatorOpen } from './navigator/navigatorStore';
import { homePinnedKeys } from './homePinnedKeys';
import { useModuleDescriptions } from './strings/useModuleDescriptions';
import { useShellNav } from './useShellNav';

/**
 * «Закріплені модулі» Головної (прототип v4): підпис великими літерами й «Переглянути всі N модулів →» (навігатор модулів Ctrl+K; N —
 * модулі простору без платформних і системних); картки модулів — назва 600 і кількість записів IBM Plex Mono праворуч, опис модуля 12px
 * (опис головного типу запису, як підзаголовок сторінки модуля).
 */
export function PinnedModulesGrid({ ws }: IHomeCardProps) {
  const { t } = useTranslation();
  const label = useLabel();
  const { me, catalog } = useShellNav(ws);
  const installed = listedModuleCount(catalog) ?? 0;
  const keys = homePinnedKeys(me, catalog, ws);
  const describe = useModuleDescriptions(catalog, keys);
  return (
    <section className="hp-pinned" aria-label={t('homePage.pinned')}>
      <div className="hp-pinned__head">
        <span className="hp-pinned__label">{t('homePage.pinned')}</span>
        <button type="button" className="hp-pinned__all" onClick={() => setNavigatorOpen(true)}>{t('homePage.browseAll', { count: installed })}</button>
      </div>
      <div className="hp-mods">
        {keys.map((key) => {
          const m = catalog?.modules.find((x) => x.key === key);
          return (
            <Link key={key} className="hp-mod" to={routes.module(key)}>
              <span className="hp-mod__top"><span className="hp-mod__name">{label(m?.name) || key}</span><span className="hp-mod__count">{moduleCount(m)}</span></span>
              <span className="hp-mod__desc">{describe(key)}</span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}
